import { mat4, vec3 } from "wgpu-matrix";

export default abstract class Camera {
  aspect: number;
  fov_y: number;
  near: number;
  far: number;

  eye: Float32Array;
  up: Float32Array;

  view_matrix: Float32Array;
  projection_matrix: Float32Array;
  view_projection_matrix: Float32Array;

  constructor() {
    this.aspect = 1.0;
    this.fov_y = Math.PI / 4;
    this.near = 0.1;
    this.far = 200.0;

    this.eye = vec3.fromValues(0, 0, 0);
    this.up = vec3.fromValues(0, 1, 0);

    this.view_matrix = mat4.identity();
    this.projection_matrix = mat4.identity();
    this.view_projection_matrix = mat4.identity();
  }

  set_aspect(aspect: number) {
    this.aspect = aspect;
    this.update_matrices();
  }

  set_projection(fov_y: number, near: number, far: number) {
    this.fov_y = fov_y;
    this.near = near;
    this.far = far;
    this.update_matrices();
  }

  protected update_projection_matrix() {
    this.projection_matrix = mat4.perspective(
      this.fov_y,
      this.aspect,
      this.near,
      this.far
    );
  }

  protected update_view_projection_matrix() {
    this.view_projection_matrix = mat4.multiply(
      this.projection_matrix,
      this.view_matrix
    );
  }

  abstract update_matrices(): void;
}
